export const beforeItems: string[] = [
  'Hours lost hunting for worksheets every week',
  'Random printables that don’t build on each other',
  'No clear scope or sequence across the year',
  'Missing answer keys — grading eats your evenings',
  'Drills with no real-world hook, so students tune out',
]

export const afterItems: string[] = [
  'A full year mapped out, unit by unit',
  'Theory, examples, and practice that build in order',
  'A clear scope and sequence aligned to Common Core',
  'Every answer key included — grade in minutes',
  'Real-world projects that make math finally click',
]

export const transformationStats: [string, string][] = [
  ['600', 'PAGES READY TO TEACH'],
  ['6 UNITS', 'IN EVERY SINGLE GRADE'],
  ['100%', 'ANSWER KEYS INCLUDED'],
]
